export const LYRA_API_URL = 'https://api.lyra.finance';
//# sourceMappingURL=links.js.map